import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { green, red } from '@material-ui/core/colors';
import Switch from '@material-ui/core/Switch';

const GreenSwitch = withStyles({
  switchBase: {
    color: red[900],
    '&$checked': {
      color: green[800]
    },
    '&$checked + $track': {
      backgroundColor: green[500]
    }
  },
  checked: {},
  track: {
    backgroundColor: red[600]
  }
})(Switch);

export default function CustomGreenSwitch(props) {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <GreenSwitch
            disabled={props.disabled}
            id={props.id}
            checked={props.checked}
            onChange={props.onChange}
            name={props.name}
            aria-label={props.ariaLabel}
          />
        }
      />
    </FormGroup>
  );
}
